import React from 'react';

import s from './Divider.module.scss';

export function Divider() {
  return <div className={s.root} />;
}
